import type {
  RegularInstantConfigBucketing,
  ShortInstantConfigBucketing,
} from "./types";

export function mapToRegularBucketing(
  short: ShortInstantConfigBucketing,
): RegularInstantConfigBucketing {
  return {
    source: short.s,
    rules: {
      defaultKeyValue: short.r.k,
      ranges: short.r.r.map((range) => ({
        start: range.s,
        end: range.e,
        keyValue: range.k,
      })),
    },
  };
}
